import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';
import { ButtonText, ThemedButton } from 'core/controls';

const ProgressNav = ({ steps, next }) => {
  const links = steps.map(step => {
    const { active, visited, index, key, path } = step;
    const stepClassName = `progress-nav__step ${
      active ? 'progress-nav__step--active' : ''
    } ${!active && visited ? 'progress-nav__step--visited' : ''}`;
    const linkClassName = `progress-nav__link ${
      active ? 'progress-nav__link--active' : ''
    } ${!active && visited ? 'progress-nav__link--visited' : ''}`;

    return (
      <div key={key} className={stepClassName}>
        <Link id={`progress-nav__${key}`} to={path} className={linkClassName}>
          <span className="progress-nav__number">{index}</span>
          <span className="progress-nav__text">
            <Translate value={key} />
          </span>
        </Link>
      </div>
    );
  });

  const nextSection = next && (
    <div>
      <ThemedButton
        as={Link}
        analytics="button"
        primary
        className="progress-nav__button"
        theme={{ cadillac: 'button--alternate' }}
        to={next.path}
        data-dtm="global nav"
        id="large-breakpoint-next-button">
        <ButtonText>
          <Translate value="byo.page.general.next.step" />
        </ButtonText>
      </ThemedButton>
    </div>
  );

  return (
    <Fragment>
      <div className="progress-nav__bar">{links}</div>
      {nextSection}
    </Fragment>
  );
};

export default ProgressNav;
